
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPropertyByQuestionnaireId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPropertyByQuestionnaireId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"questionnaireId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questionnaireId"}}},{"kind":"Argument","name":{"kind":"Name","value":"propertyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyResult"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aliasName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableStartTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headPicUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxBa"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxBd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minBa"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxSqrFt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minBd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minOriginalPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minSqrFt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceReduction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amenities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catalogUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"catalogValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"floorPlanModeUnit"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorPlanBathroomNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorPlanBedroomNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorPlanName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minArea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"floorPlanIndex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableUnits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rentPrices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaseTerm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"intention"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableStartTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preTourEndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preTourStartDate"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prospectId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1037}};
    doc.loc.source = {"body":"query SearchPropertyByQuestionnaireId($questionnaireId: String, $propertyId: Long) {\n  searchPropertyByQuestionnaireId(questionnaireId: $questionnaireId, propertyId: $propertyId) {\n    propertyResult {\n      address\n      aliasName\n      availableStartTime\n      headPicUrl\n      id\n      maxBa\n      maxBd\n      minBa\n      maxSqrFt\n      minBd\n      minOriginalPrice\n      minPrice\n      minSqrFt\n      name\n      priceReduction\n      state\n      amenities {\n        catalogName\n        catalogUrl\n        catalogValue\n      }\n      floorPlanModeUnit {\n        availableTime\n        floorPlanBathroomNum\n        floorPlanBedroomNum\n        floorPlanName\n        floorUrl\n        maxArea\n        minArea\n        floorPlanIndex\n        availableUnits {\n          id\n          name\n          rentPrices {\n            leaseTerm\n            discountAmount\n          }\n          intention\n          availableStatus\n          availableStartTime\n          preTourEndDate\n          preTourStartDate\n        }\n      }\n    }\n    prospectId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SearchPropertyByQuestionnaireId"] = oneQuery(doc, "SearchPropertyByQuestionnaireId");
        
